import React from 'react'
import { NOOP, getStyle } from '@fedsim/helpers'
import { Box } from '@mui/material'

import { ImageBlock } from '../../image-block';
import { Actions } from '../../actions'
import { useAvatarStyles } from './generic.avatar.style'
import { HeaderBody } from '../../typography'

const getImage = item => item?.image
  || item?.brands?.[0]?.image || item?.brand?.image
  || item?.wrestler?.image || item?.wrestlers?.[0]?.image
  || item?.championship?.image || item?.championships?.[0]?.image
  || item?.appearances?.[0]?.wrestler?.image

export function GenericAvatars({
  itemStyle = getStyle,
  // activeIndex = -1,
  actions = [],
  collection = [],
  onClick = NOOP
}) {
  const styles = useAvatarStyles()
  if (collection.length === 0) {
    return null
  }
  return (
    <Box className={styles.container}>
      <ul className={styles.list}>
        {collection.map((item, index) => {
          const key = item?.id ? item.id : index
          const payload = item?.id ? item.id : item
          const singleClick = () => onClick(payload, index, item)
          const style = item ? itemStyle(item) : {}
          const image = getImage(item)
          const { backgroundColor } = style
          return (
            <li
              key={key}
              className={styles.listitem}
              onClick={singleClick}>
              <Box className={styles.arrangement}>
                <Box mb={.3}>
                  <ImageBlock
                    alt={item?.name}
                    image={image}
                    width="100%"
                    height="160px"
                    backgroundColor={backgroundColor}
                    className={styles.avatar}
                  />
                </Box>
                <Box 
                  sx={style}
                  className={styles.chip}>
                  <HeaderBody>{item?.name}</HeaderBody>
                </Box>
              </Box>
              {actions.length > 0 && (
                <Box>
                  <Actions
                    actions={actions}
                    payload={item}
                    orientation="vertical"
                  />
                </Box>
              )}
            </li>
          )
        })}
      </ul>
    </Box>
  )
}
